(function() {

  window.CLD_FIELD_DEFINITIONS = {
    'brand-name': {
      label: 'Your Brand Name',
      placeholder: 'YOUR BRAND NAME',
      maxLength: 30,
      required: true
    },
    'scent': {
      label: 'Scent',
      placeholder: 'SCENT',
      maxLength: 30,
      required: false
    }
  };

  window.CLD_TEMPLATES = [
    
    {
  id: 'coastal-stamp-blue',
  name: 'Coastal Stamp Blue',
  category: 'Coastal',
  tags: ['coastal', 'beach', 'ocean', 'blue', 'clean', 'nautical'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_2_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 450,
      y: 60,
      fontFamily: 'Roboto Slab',
      fontWeight: 400,
      fontSize: 42,
      color: '#0d1f5e',
      align: 'center',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 450,
      y: 275,
      fontFamily: 'Roboto Slab',
      fontWeight: 400,
      fontSize: 100,
      color: '#0d1f5e',
      align: 'center',
      valign: 'middle'
    }
  ]
},

{
  id: 'coastal-stamp-coral',
  name: 'Coastal Stamp Coral',
  category: 'Coastal',
  tags: ['coastal', 'beach', 'ocean', 'blue', 'clean', 'nautical'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_17_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 450,
      y: 60,
      fontFamily: 'Roboto Slab',
      fontWeight: 400,
      fontSize: 42,
      color: '#f28264',
      align: 'center',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 450,
      y: 275,
      fontFamily: 'Roboto Slab',
      fontWeight: 400,
      fontSize: 100,
      color: '#f28264',
      align: 'center',
      valign: 'middle'
    }
  ]
},
    
    
{
  id: 'coastal-stamp-green',
  name: 'Coastal Stamp Green',
  category: 'Coastal',
  tags: ['coastal', 'beach', 'ocean', 'blue', 'clean', 'nautical'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_18_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 450,
      y: 60,
      fontFamily: 'Roboto Slab',
      fontWeight: 400,
      fontSize: 42,
      color: '#7dcfb6',
      align: 'center',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 450,
      y: 275,
      fontFamily: 'Roboto Slab',
      fontWeight: 400,
      fontSize: 100,
      color: '#7dcfb6',
      align: 'center',
      valign: 'middle'
    }
  ]
},
   

{
  id: 'coastal-stamp-navy',
  name: 'Coastal Stamp Navy',
  category: 'Coastal',
  tags: ['coastal', 'beach', 'ocean', 'blue', 'clean', 'nautical'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_19_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 450,
      y: 60,
      fontFamily: 'Roboto Slab',
      fontWeight: 400,
      fontSize: 42,
      color: '#004e98',
      align: 'center',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 450,
      y: 275,
      fontFamily: 'Roboto Slab',
      fontWeight: 400,
      fontSize: 100,
      color: '#004e98',
      align: 'center',
      valign: 'middle'
    }
  ]
},

    {
  id: 'panic-mode-activated',
  name: 'Panic Mode Activated',
  category: ['Life', 'Funny'],  
  tags: ['panic', 'anxiety', 'stress', 'funny'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_4_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 25,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'left',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 870,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'right',
      valign: 'middle'
    }
  ]
},

    {
  id: 'get-a-mortgage',
  name: 'Get A Mortgage',
  category: 'Home',
  tags: ['Home', 'moving', 'decor', 'buying a house'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_5_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 25,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'left',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 870,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'right',
      valign: 'middle'
    }
  ]
},

    {
  id: 'moved-closer',
  name: 'Moved Closer To Me',
  category: ['Home', 'Friends'],
  tags: ['Home', 'moving', 'decor', 'friend','buying a house'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_6_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 25,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'left',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 870,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'right',
      valign: 'middle'
    }
  ]
},

    {
  id: 'shut-the-front-door',
  name: 'Shut The Front Door',
  category: ['Home'],
  tags: ['Home', 'moving', 'decor', 'buying a house'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_7_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 25,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'left',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 870,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'right',
      valign: 'middle'
    }
  ]
},

    {
  id: 'welcome-to-the-neighborhood',
  name: 'Welcome to the Neighborhood',
  category: ['Home'],
  tags: ['Home', 'moving', 'decor', 'buying a house'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_8_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 25,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'left',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 870,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'right',
      valign: 'middle'
    }
  ]
},

    {
  id: 'fight-bear-for-you',
  name: 'Fight A Bear For You',
  category: ['Friends', 'Funny'],
  tags: ['Friend', 'caring', 'protection', 'funny'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_10_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 25,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'left',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 870,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'right',
      valign: 'middle'
    }
  ]
},

    {
  id: 'everyone-sucks-except-us',
  name: 'Everyone Sucks Except Us',
  category: ['Friends', 'Funny'],
  tags: ['Friend', 'caring', 'protection', 'funny'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_11_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 25,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'left',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 870,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'right',
      valign: 'middle'
    }
  ]
},

    {
  id: 'unpaid-therapist',
  name: 'Unpaid Therapist',
  category: ['Friends', 'Life'],
  tags: ['Friend', 'caring', 'therapy', 'funny'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_12_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 25,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'left',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 870,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'right',
      valign: 'middle'
    }
  ]
},

    {
  id: 'her-we-go-again',
  name: 'Here We Go Again',
  category: ['Funny', 'Motivation'],
  tags: ['fuck', 'motivation', 'therapy', 'funny'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_13_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 25,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'left',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 870,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'right',
      valign: 'middle'
    }
  ]
},

    {
  id: 'best-dog-mom-ever',
  name: 'Best Dog Mom Ever',
  category: ['Pets'],
  tags: ['dog', 'pet'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_14_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 25,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'left',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 870,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'right',
      valign: 'middle'
    }
  ]
},

    {
  id: 'deep-breaths-not-working',
  name: 'Deep Breaths Arent Working',
  category: ['Funny', 'Life'],
  tags: ['funny', 'caring', 'therapy', 'relax'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_15_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 25,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'left',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 870,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'right',
      valign: 'middle'
    }
  ]
},

 {
      id: 'my-last-fuck',
      name: 'My Last Fuck',
      category: ['Life', 'Funny'],
      tags: ['bold', 'funny', 'edgy', 'humor', 'black'],
      backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Mockup_Template_11_My_Last_Fuck-blank.png',
      fields: [
        {
          fieldId: 'brand-name',
          x: 38,
          y: 490,
          fontFamily: 'Roboto Condensed',
          fontWeight: 600,
          fontSize: 42,
          color: '#ffffff',
          align: 'left'
        },
        {
          fieldId: 'scent',
          x: 38,
          y: 535,
          fontFamily: 'Roboto Condensed',
          fontWeight: 400,
          fontSize: 36,
          color: '#ffffff',
          align: 'left'
        }
      ]
    },

    

    {
  id: 'not-drunk-enough',
  name: 'Not Drunk Enough',
  category: ['Drinking', 'Funny'],
  tags: ['drunk', 'drinking', 'beer', 'alcohol', 'funny'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_3_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 450,
      y: 475,
      fontFamily: 'Roboto Condensed',
      fontWeight: 600,
      fontSize: 36,
      color: '#ffffffff',
      align: 'center',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 450,
      y: 575,
      fontFamily: 'Roboto Slab',
      fontWeight: 400,
      fontSize: 24,
      color: '#ffffffff',
      align: 'center',
      valign: 'middle'
    }
  ]
},

    {
  id: 'burn-your-stress-away',
  name: 'Burn Your Stress Away',
  category: ['Life'],
  tags: ['funny', 'caring', 'therapy', 'relax'],
  backgroundUrl: 'https://cdn.shopify.com/s/files/1/0556/3167/5564/files/Label_Template_16_Blank.png',
  fields: [
    {
      fieldId: 'brand-name',
      x: 25,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'left',
      valign: 'middle'
    },
    {
      fieldId: 'scent',
      x: 870,
      y: 520,
      fontFamily: 'Oswald',
      fontWeight: 600,
      fontSize: 36,
      color: '#000000',
      align: 'right',
      valign: 'middle'
    }
  ]
}



    
  ];

})();